import { type FunctionComponent } from "react";
import clsx from "clsx";
import type { StampType } from "~/database/stamps.model";
import StampButton from "./StampButton";

interface StampListProps {
  stamps: {
    stamp: StampType;
    count: number;
    isStamp: boolean;
  }[];
  postId: string;
}

const StampList: FunctionComponent<
  StampListProps
> = ({ stamps, postId }) => {
  return (
    <div
      className={clsx(
        "flex",
        "gap-x-15",
        "gap-y-8",
        "items-center",
        "flex-wrap",
        "max-md:gap-x-10",
      )}
    >
      {stamps.map((el, i) => {
        return (
          <StampButton
            key={i}
            {...el}
            postId={postId}
          ></StampButton>
        );
      })}
    </div>
  );
};

export default StampList;
